import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { Icon } from 'vant';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
import { DEFAULT_LANG, getStoredLang, normalizeLang } from './utils/lang'
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)
const stored = localStorage.getItem('lang')
const lang = stored ? normalizeLang(stored) : DEFAULT_LANG
localStorage.setItem('lang', lang)
const i18n = new VueI18n({
  globalInjection: true, 
  locale: getStoredLang(),
  fallbackLocale: 'en',
  messages: {
    'de': require('./assets/languages/de.json'),
    'fr': require('./assets/languages/fr.json'),
    'en': require('./assets/languages/en.json'),
    'it': require('./assets/languages/it.json'),
    'zh': require('./assets/languages/zh.json'),
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
